import React from 'react'

import {
  createCluster,
  deleteCluster,
  fetchClusters,
  updateCluster
} from 'api/apartment'

import ApartmentApiCrudPage from '../shared/ApartmentApiCrudPage'

const columns = [
  { name: 'name', label: 'Cluster' },
  { name: 'slug', label: 'Slug', options: { filter: false } },
  { name: 'apartmentCount', label: 'Complexes', options: { filter: false } },
  {
    name: 'active',
    label: 'Active',
    options: { customBodyRender: (v) => (v ? 'Yes' : 'No') }
  }
]

const fields = [
  { name: 'name', label: 'Cluster Name', type: 'text' },
  { name: 'active', label: 'Active', type: 'checkbox' }
]

const ApartmentClusters = () => (
  <ApartmentApiCrudPage
    title="Clusters"
    tableTitle="Clusters"
    entityLabel="Cluster"
    subtitle="Geographic zones grouping complexes"
    showSelector={false}
    fetchList={fetchClusters}
    createItem={createCluster}
    updateItem={updateCluster}
    deleteItem={deleteCluster}
    columns={columns}
    fields={fields}
    emptyValues={{ name: '', active: true }}
  />
)

export default ApartmentClusters
